import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data.service';
import { MessageService } from '../../../services/message.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-form-surcharges',
  templateUrl: './form-surcharges.component.html',
  styleUrls: ['./form-surcharges.component.css'],
})
export class FormSurchargesComponent implements OnInit {
  url: string = 'openai';
  loading: boolean = false;
  id: string = '';
  form!: FormGroup;

  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Distance',
      route: '/logistics/fees',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Volume',
      route: '/logistics/fees/volume',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-clock',
      bgClass: 'bg-white',
      desc: 'Weight',
      route: '/logistics/fees/weight',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-city',
      bgClass: 'bg-white',
      desc: 'Runner',
      route: '/logistics/fees/task',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-white',
      desc: 'Surcharges',
      route: '/logistics/fees/surcharges',
    },
    /* {
      label: '',
      value: 0,
      icon: 'fas fa-user-check',
      bgClass: 'bg-white',
      desc: 'EMM',
      route: '/logistics/fees/emm',
    }, */
  ];

  resumenCardsTwo = [
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Drivers',
      route: '/logistics',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-user',
      bgClass: 'bg-white',
      desc: 'Customers',
      route: '/logistics/customers',
    },
    {
      //label: 'TN',
      value: '',
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Metrics',
      route: '/logistics/fees',
    },
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {
    this.initForm();
  }

  private initForm(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      items: ['', [Validators.required]],
      surcharge: ['', [Validators.required, Validators.min(0)]],
      apply: ['', [Validators.required]],
      category: [''],
      status: [true], // 👈 agregado para enviar true/false
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.loading = true;
      if (this.id) {
        this.updateData();
      } else {
        this.createData();
      }
    } else {
      this.messageService.add(
        'Por favor complete todos los campos requeridos',
        'warning',
      );
      Object.keys(this.form.controls).forEach((key) => {
        const control = this.form.get(key);
        if (control?.invalid) {
          control.markAsTouched();
        }
      });
    }
  }

  private prepareFormData(): any {
    const formData = { ...this.form.value };

    // Convertir el string de items a array
    if (typeof formData.items === 'string') {
      formData.items = formData.items
        .split(',')
        .map((item: string) => item.trim())
        .filter((item: string) => item.length > 0);
    }

    // Asegurarse de que surcharge sea un número
    formData.surcharge = Number(formData.surcharge);

    // status ya viene como true/false del checkbox
    return formData;
  }

  createData(): void {
    const formData = this.prepareFormData();
    this.dataService
      .postData(`${this.url}/surcharges_add`, formData)
      .subscribe({
        next: (response: any) => {
          if (response && response.rst === true) {
            this.messageService.add('Surcharge creado exitosamente', 'success');
            this.router.navigate(['/logistics/fees/surcharges']);
          } else {
            this.router.navigate(['/logistics/fees/surcharges']);
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al crear:', error);
          this.router.navigate(['/logistics/fees/surcharges']);
          this.loading = false;
        },
      });
  }

  getData(): void {
    this.loading = true;
    this.dataService
      .getData(`${this.url}/surcharges_get/${this.id}`)
      .subscribe({
        next: (response: any) => {
          if (response && response.data) {
            const items = Array.isArray(response.data.items)
              ? response.data.items.join(', ')
              : response.data.items;

            this.form.patchValue({
              name: response.data.name,
              items: items,
              surcharge: response.data.surcharge,
              apply: response.data.apply,
              category: response.data.category,
              status: response.data.status ?? true, // 👈 cargar valor del backend
            });
          } else {
            this.messageService.add('No se encontró el surcharge', 'warning');
            this.router.navigate(['/logistics/fees/surcharges']);
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al obtener datos:', error);
          this.messageService.add(
            'Error al cargar los datos: ' + (error.error?.msg || error.message),
            'danger',
          );
          this.loading = false;
          this.router.navigate(['/logistics/fees/surcharges']);
        },
      });
  }

  updateData(): void {
    const formData = this.prepareFormData();
    this.dataService
      .putData(`${this.url}/surcharges_edit/${this.id}`, formData)
      .subscribe({
        next: (response: any) => {
          if (response && response.rst === true) {
            this.messageService.add(
              'Surcharge actualizado exitosamente',
              'success',
            );
            this.router.navigate(['/logistics/fees/surcharges']);
          } else {
            this.messageService.add(
              response?.msg || 'Error al actualizar el surcharge',
              'danger',
            );
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al actualizar:', error);
          this.messageService.add(
            'Error al actualizar el surcharge: ' +
              (error.error?.msg || error.message),
            'danger',
          );
          this.loading = false;
        },
      });
  }

  onCancel(): void {
    this.router.navigate(['/logistics/fees/surcharges']);
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }
}
